// extracted by mini-css-extract-plugin
module.exports = {"warning":"warning__25Gt-","warning-body":"warning-body__3hAxn"};